import * as Api from '@ViewModels';

function escapeHtml(text: string): string {
	return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/** Build the raw rich-text document the API expects from plain text, one paragraph per line. */
export function toActionItemContent(text: string): Api.IRawRichTextContentState {
	const html = text
		.split(/\r?\n/)
		.map(line => `<p>${escapeHtml(line)}</p>`)
		.join('');
	return Api.createRawRichTextContentStateWithHtmlStringValue(html);
}
